export const SET_GLOBAL_FILTER_CONTENT = "SET_GLOBAL_FILTER_CONTENT";
export const SET_ACTIVE_FILTER_ITEM = "SET_ACTIVE_FILTER_ITEM"
export const SET_CURRENT_GLOBAL_FILTER = "SET_CURRENT_GLOBAL_FILTER"
export const SET_GLOBAL_FILTERS_LIST = "SET_GLOBAL_FILTERS_LIST"
export const SET_VISIBILITY = "SET_VISIBILITY"
export const UPDATE_GLOBAL_FILTER = "UPDATE_GLOBAL_FILTER"
export const REFRESH_ALL_STATUS = "REFRESH_ALL_STATUS"
export const RESET_POPUP = "RESET_POPUP"
export const SET_POPUP = "SET_POPUP"
export const CLEAR = "CLEAR"
export const SET_NAVIGATION_STATE = "SET_NAVIGATION_STATE"
export const SET_DASHBOARD_SWITCH_STATE = "SET_DASHBOARD_SWITCH_STATE"

/**
 * Sets Global Filter content
 * 
 * @param {Object} globalFilterContent - Global filter content
 */
export const setGlobalFilterContent = (globalFilterContent) => {
  return (dispatch) => {
    dispatch({
      type: SET_GLOBAL_FILTER_CONTENT,
      payload: globalFilterContent,
    });
  };
}

/**
 * Sets active filter item
 * 
 * @param {String} filterItemId - Filter item id
 */
export const setActiveFilterItem = (filterItemId) => {
  return (dispatch) => {
    dispatch({
      type: SET_ACTIVE_FILTER_ITEM,
      payload: filterItemId,
    });
  };
}

/**
 * Sets current global filter
 * 
 * @param {String} globalFilterId - Global filter id
 */
export const setCurrentGlobalFilter = (globalFilterId) => {
  return (dispatch) => {
    dispatch({
      type: SET_CURRENT_GLOBAL_FILTER,
      payload: globalFilterId,
    });
  };
}

/**
 * Sets global filters list
 * 
 * @param {Array} globalFiltersList - Global filters list
 */
export const setGlobalFiltersList = (globalFiltersList) => {
  return (dispatch) => {
    dispatch({
      type: SET_GLOBAL_FILTERS_LIST,
      payload: globalFiltersList,
    });
  };
}

/**
 * Updates global filter
 * 
 * @param {Object} globalFilter - Global filter
 */
export const updateGlobalFilter = (globalFilter) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_GLOBAL_FILTER,
      payload: globalFilter,
    });
  };
}

/**
 * Opens popup with the given content
 * 
 * @param {*} payload 
 * @returns 
 */
export const setGlobalFiltersPopup = (payload) => {
  return (dispatch) => {
    dispatch({
      type: SET_POPUP,
      payload: payload,
    });
  }
}

/**
 * Resets & closes popup
 * 
 * @returns 
 */
export const resetGlobalFiltersPopup = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_POPUP,
    });
  }
}

export const clearGlobalFiltersReduxState = (totalClean=true) => {
  return (dispatch) => {
    dispatch({
      type: CLEAR,
      payload: totalClean
    });
  }
}

export const setRefreshAllStatus = (payload) => {
  return (dispatch) => {
    dispatch({
      type: REFRESH_ALL_STATUS,
      payload: payload
    });
  }
}

export const setNavigationState = (payload) => {
  return (dispatch) => {
    dispatch({
      type: SET_NAVIGATION_STATE,
      payload: payload
    })
  }
}

export const setDashboardSwitchState = (payload) => {
  return (dispatch) => {
    dispatch({
      type: SET_DASHBOARD_SWITCH_STATE,
      payload: payload
    })
  }
}